import type { EllipseI } from "tweenly"
import Border from "./ExpandableSections/Border"
import Fill from "./ExpandableSections/Fill"
import Filters from "./ExpandableSections/Filters"
import MarginAndPadding from "./ExpandableSections/MarginAndPadding"
import Appearance from "./ExpandableSections/Appearance"
import SizeAndPosition from "./ExpandableSections/SizeAndPosition"
import Transforms from "./ExpandableSections/Transforms"

interface Props {
    object: EllipseI
    handleSetStyleValue: (property: any, value: any) => void
    handleSetObjectValue: (property: any, value: any) => void
    handleSetAttributeValue: (property: any, value: any) => void
}

// Same as ItemTools minus Corner radius — an ellipse keeps its radii pinned to 50%
const EllipseTools = ({
    object,
    handleSetStyleValue,
    handleSetObjectValue,
    handleSetAttributeValue,
}: Props) => {
    return (
        <div>
            <SizeAndPosition object={object} handleSetValue={handleSetStyleValue} />
            <Appearance object={object} handleSetValue={handleSetStyleValue} />
            <Fill
                object={object}
                handleSetStyleValue={handleSetStyleValue}
                handleSetObjectValue={handleSetObjectValue}
                handleSetAttributeValue={handleSetAttributeValue}
            />
            <MarginAndPadding object={object} handleSetValue={handleSetStyleValue} />

            <Border object={object} handleSetValue={handleSetStyleValue} />

            <Filters object={object} handleSetObjectValue={handleSetObjectValue} />

            <Transforms
                object={object}
                handleSetStyleValue={handleSetStyleValue}
                handleSetObjectValue={handleSetObjectValue}
            />
        </div>
    )
}

export default EllipseTools
